export default __webpack_public_path__ + "static/media/Group 4.732cedb5.png";